export default "__VITE_ASSET__Bfm3ISuT__"